var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tableTab"},_vm._l((_vm.tabData),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.itemBtn(item, index)}}},[_c('div',{staticClass:"title",class:{
        active: _vm.active === index,
      }},[_vm._v(" "+_vm._s(item.title)+" "),(_vm.active === index)?_c('div',{staticClass:"line"}):_vm._e()])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }